export { default } from './IconGradientPreloader';
